<template>
  <v-container fluid>
    <v-row>
      <v-col cols="4">
        <task-details v-if="taskEvent" :task="taskEvent" />
      </v-col>
      <v-col cols="4">
        <v-sheet rounded>
          <client-summary v-if="taskEvent && taskEvent.user" :userId="taskEvent.user.id" />
        </v-sheet>
      </v-col>
      <v-col cols="4">
        <template v-if="chatsForUser && chatsForUser.length > 0 && taskEvent.user">
          <div class="d-flex justify-space-between pt-6">
            <h2 class="primary--text">Chats</h2>
          </div>
          <div v-for="chat in chatsForUser" :key="chat.id">
            <chat-listing-card :chat="chat" :userId="taskEvent.user.id" class="mt-2 mb-8" />
          </div>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { extractNodes } from "@/lib/array";
import { TASK_EVENT_BY_ID_QUERY } from "@/graphql/queries/task";
import ClientSummary from "@/components/task/components/ClientSummary";
import TaskDetails from "@/components/task/components/TaskDetails";
import { CHATS_FOR_USER } from "@/graphql/queries/chat";
import ChatListingCard from "@/components/chats/ChatListingCard";
import { decodeId } from "@/lib/string";

export default {
  name: "TaskView",
  props: ["taskId"],
  components: {
    ClientSummary,
    TaskDetails,
    ChatListingCard,
  },
  data() {
    return {
      taskEvent: null,
      staff: [],
      chatsForUser: [],
    };
  },

  apollo: {
    taskEvent: {
      query: TASK_EVENT_BY_ID_QUERY,
      variables() {
        return {
          taskEventId: decodeId(this.taskId),
        };
      },
      fetchPolicy: "cache-and-network",
    },
    chatsForUser: {
      query: CHATS_FOR_USER,
      variables() {
        return {
          userId: this.taskEvent.user.id,
        };
      },
      fetchPolicy: "cache-and-network",
      update(data) {
        const chats = extractNodes(data.chatsForUser.edges);
        this.hasCoachingChat = chats.filter((chat) => chat.type == "COACH").length > 0;
        return chats.filter((chat) => chat.type !== "ACCOUNTABILITY");
      },
      skip() {
        return !this.taskEvent || !this.selectedEvent.user?.id;
      },
    },
  },
};
</script>
